import React from 'react';
import { useQuery } from 'react-fetching-library';
import Page from '../../components/Page';
import { Card, CardContent } from '@mui/material';
import AddDocument from '../../sections/employee/generics/work-standard/AddDocument';
import WorkStandardList from '../../sections/employee/generics/work-standard/WorkStandardList';

import { getPersonalDataProtectionDocumentsAction,
  downloadPersonalDataProtectionDocumentAction,
  deletePersonalDataProtectionDocumentAction,
  submitPersonalDataProtectionDocumentAction } from '../../services/request';

export default function PersonalDataProtectionDocument () {
  const [search, setSearch] = React.useState(null);
  const [documents, setDocuments] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [count, setCount] = React.useState(0);
  const { loading, payload, error, query } = useQuery(getPersonalDataProtectionDocumentsAction('GET', search, page, pageSize));

  const queryCallback = data => {
    setSearch(data.search);
    query('GET', search, data.page, pageSize);
  };

  React.useEffect(() => {
    if (!loading && !error) {
      setDocuments(payload.results);
      setCount(payload.count);
    }
  }, [loading]);

  return (
    <Page title="Dokumentacja dotycząca ochrony danych osobowych">
      <Card>
        <CardContent>
          <>
            <AddDocument setDocuments={setDocuments}
              submitDocumentAction={submitPersonalDataProtectionDocumentAction}
              getDocumentsAction={getPersonalDataProtectionDocumentsAction}
              setCount={setCount} />
            <WorkStandardList
              documents={documents}
              queryCallback={queryCallback}
              setDocuments={setDocuments}
              downloadDocumentAction={downloadPersonalDataProtectionDocumentAction}
              deleteDocumentAction={deletePersonalDataProtectionDocumentAction}
              submitDocumentAction={submitPersonalDataProtectionDocumentAction}
              getDocumentsAction={getPersonalDataProtectionDocumentsAction}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              count={count}
              setCount={setCount}
            />
          </>
        </CardContent>
      </Card>
    </Page>
  );
};
